import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_CLIENT_LOGO,
  SET_PAGE,
  SET_SEARCH,
  SHOW_MESSAGE,
  SET_SORT_BY,
  SET_ORDER_BY,
} from "shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getClientLogo = () => {
  return (dispatch, getState) => {
    const state = getState().clientLogo;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/client-logo/list", {
        search: state.search,
        page: state.page,
        orderby: state.orderby,
        sortby: state.sortby,
        limit: 10,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: GET_CLIENT_LOGO, payload: data.data.data });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addClientLogo = (formData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/client-logo/add", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Client logo added successfully",
          });
          dispatch(getClientLogo());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const editClientLogo = (formData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/client-logo/edit", formData)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Client logo updated successfully",
          });
          dispatch(getClientLogo());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteClientLogo = (id) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/client-logo/delete", { id })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Client logo deleted successfully",
          });
          dispatch(getClientLogo());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
